import {connect} from "react-redux";
import CompleteBaActivity from "./Complete";
import {bindActionCreators} from "redux";
import {documentUploadUrlPublic} from "../../../../service/fileUpload/action";
import {viewActivity} from "../../../../service/Activity/action";
import {getPendingActivity} from "../../../../service/BA/action";
import {activityTypes, getSenior} from "../../../../service/Dealer/action";
import {saveActivity, markAttendance} from "../../../../service/BA/action";
import {isCheckout} from "../../../../service/CarService/action";
const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    senior: state.Dealer.senior,
    activityByIdDetails:state.Activity.activityByIdDetails,
    saveActivityRes:state.BA.saveActivityRes,
    pendingActivity:state.BA.pendingActivity,
    attendance:state.BA.attendance,
    activityTypesDetails:state.Dealer.activityTypesDetails,
    isCheckoutDetails:state.CarService.isCheckout,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            viewActivity,
            saveActivity,
            getPendingActivity,
            activityTypes,
            getSenior,
            isCheckout,
            markAttendance
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(CompleteBaActivity);
